import ptLocale from 'element-ui/lib/locale/lang/pt'
import agrZh from './agr-en'
export default {
    ai: {
        loadingError1: 'Não foi possível carregar o relatório',
    },
    // 登录页面
    login: {
        loginAndRegister: 'Inscrever-se / Entrar',
        registerAndLogin: 'Entrar / Inscrever-se',
        userLogin: 'Entrar',
        title: 'Contas de celular e e-mail são independentes.',
        mobileLogin: 'Telefone',
        emailLogin: 'E-mail',
        email: 'E-mail',
        loginBtn: 'Entrar',
        autoLogin: 'Lembrar-me',
        retransmission: '{item}s',
        formList: [
            {
                label: 'Insira o seu número de telefone',
                placeholder: 'Enviar',
            },
            {
                label: 'Código verif',
                placeholder: 'Inserir código de verificação',
            },
            {
                label: 'Por favor, insira o seu e-mail',
            },
        ],
        btn: {
            submit: 'Criar Conta',
            title: 'Para obter dados precisos, é importante inserir corretamente altura, gênero e idade.',
        },
        rule: {
            phone: {
                requiredMsg: 'Formato de Número de Telefone Inválido',
                patternMsg: 'Telefone não registrado, crie sua conta',
            },
            authCode: {
                requiredMsg: 'Código de Verificação Errado, Por Favor, Digite Novamente',
            },
            email: {
                requiredMsg: 'Formato de E-mail Errado',
                patternMsg: 'E-mail Não Registrado, Crie Sua Conta',
            },
        },
        codeSuccess: 'O código de verificação foi enviado, por favor, verifique.',
        success: 'Envio bem-sucedido',
        error: 'Falha no Envio',
        loginSuccess: 'Login bem-sucedido',
        account: {
            accountTitle: 'Entrar',
            registerTitle: 'Entrar',
            resetTitle: 'Definir palavra-passe',
            password: 'Palavra-passe',
            placeholder: 'Por favor, insira a palavra-passe',
            codeLogin: 'Iniciar sessão com código de verificação',
            accountLogin: 'Iniciar sessão com palavra-passe',
            forgotPassword: 'Esqueceu a palavra-passe?',
            registerTips:[
                'Não tem uma conta?', 
                'Entrar', 
                'A conta já existe',
                'Cadastre-se',
            ],
            checkRule: [
                '8-20 caracteres',
                'Deve conter pelo menos uma letra maiúscula',
                'Deve conter pelo menos uma letra minúscula',
                'Deve conter pelo menos um número', 
                'As palavras-passe não coincidem'
            ],
            errorTips: [
                'Palavra-passe incorreta', 
                'Falha na iniciação de sessão', 
                'Conta inexistente'
            ],
            reset:[
                'Redefinir palavra-passe', 
                "Próximo",
                'A nova palavra-passe não pode ser igual à anterior', 
                'Saltar',
                'Palavra-passe definida com sucesso'
            ],
            setPasswordTips:'A palavra-passe deve ter entre 8 e 20 caracteres e incluir letras maiúsculas, letras minúsculas e números.',
            confirmPassword: "Senha de confirmação",
        },
        switchButton: 'Iniciar sessão com palavra-passe',
        switchButton1: 'Iniciar sessão com código de verificação',
        loginTips: 'Contas não registadas serão automaticamente registadas após um início de sessão bem-sucedido.',
        otherLogin: 'Outros métodos de início de sessão',
        newEmailLogin: 'Login na caixa de correio',
        newPhoneLogin: 'Login do número de telemóvel',
        bindLineTips:'Ou',
        bindEmail: 'Iniciar sessão com e-mail vinculado',
        bindPhone: 'Iniciar sessão com número de telemóvel vinculado',
        bindAndContinue: "Vincular e continuar",
        bind: "Vincular",
        bindEmailTitle: 'Vincular e-mail',
        bindEmailTips1: "Info de e-mail {item} não encontrada",
        bindEmailTips2: "Vincule o e-mail para continuar",
        bindEmailTips3: "E-mail não vinculado. Vincule para fazer login e recuperar a senha.",
        boundTitle: 'Já se registou antes?',
        boundCenterTitle1:'Se é um novo utilizador',
        boundCenterTips1:'Crie uma conta para começar',
        boundCenterTitle2:'Se já tem uma conta',
        boundCenterTips2:'Vincule para sincronizar dados',
        boundCenterTips3:'Por favor, vincule uma conta registrada',
        boundCenterTips4:'Recomendado',
        boundCenterTips5:'Vincular {item} a conta existente',
        boundCenterTips6:'Dados e relatórios serão sincronizados',
        boundButton1: 'Criar conta com {item}',
        boundButton2: 'Vincular conta existente',
        phoneCode:"Entrar com código SMS",
        phonePassword:"Entrar com número de telemóvel e palavra-passe",
        emailCode:"Entrar com código por e-mail",
        emailPassword:"Entrar com e-mail e palavra-passe",
        accountDoesNotExist:"Esta conta ainda não está registada. Registe-se utilizando um código de verificação por e-mail ou através do {item}.",
        toRegister:"Registar",
        bindNow: "Associar agora",
        bindError:[
            'Falha na vinculação',
            'Vinculação removida com sucesso',
            'Falha ao Desassociar',
            'Falha na Autorização',
            'Falha na Autorização, Não Foi Possível Obter a Informação da Conta',
            'Conta Associada com Sucesso',
            'A conta não existe. Por favor, associe uma conta registada.',
            'Falha na associação. Esta conta já está associada à conta {item} [{nickname}].',
            'Autorizado e registado como uma conta, não é possível desvincular',
            'A conta não existe, por favor, use o código de verificação para iniciar sessão e registar',
        ],
        accountSecurity: {
            faceBook:'Conta do Facebook',
            google: 'Conta do Google',
            isBind: 'Não vinculado',
            dialogTitle: 'Confirmar remoção da vinculação?',
            dialogCenter: 'Após remover a vinculação de {item}, já não poderá usá-lo para iniciar sessão nesta conta.',
            bindFailure:'Falha na vinculação',
            bindFailureTips: 'A sua conta {item} já está vinculada à conta abaixo. Se pretender mudar a vinculação para a conta atual, inicie sessão na conta abaixo para remover primeiro a vinculação.',
            returnButton:'Confirmar e voltar'
        },
        bindEmailError: [
            "E-mail já existe. Use outro."
        ],
    },
    // 注册页面
    register: {
        mobileRegister: 'Telefone',
        emailRegister: 'E-mail',
        enroll: 'Número de Celular Já Registrado',
        enrollEmail: 'O email está registrado',
        search: 'Pesquisar',
        title: 'A conta configurada por e-mail e número de telefone são independentes uma da outra, por favor',
        needRead: {
            agree: 'Eu concordo',
            privacy: '(Política de Privacidade)',
        },
        register: 'Entrar',
        check: 'Verifique "Privacidade do Usuário"',
        newUser: 'Entrar',
        form: {
            labelList: ['Nome', '* Gênero', '* Altura', '* Idade'],
        },
        placeholder: [
            'Por favor, insira o seu nome',
            'Por favor, insira a sua altura',
            'Por favor, insira a sua idade',
        ],
        unit: ['Métrico', 'Imperial', ''],
        sexOptions: {
            male: 'Masculino',
            female: 'Feminino',
        },
        btn: 'Enviar',
        rules: {
            metricheight: [`A faixa de altura é de 2'3" - 6'7", por favor, insira novamente.`],
            heightMsg: ['A faixa de altura é de 70 - 200cm, por favor, insira novamente.'],
            ageMsg: ['A faixa de idade é de 10 - 99, por favor, insira novamente.'],
            agePointMsg: [
                'Preenchido não-inteiro: a idade só pode ser um número inteiro, por favor, preencha a idade correta',
            ],
        },
        success: 'Registro Bem-sucedido',
        userMessage: 'Insira o Nome de Usuário',
        verify: 'Insira o Código de Verificação de 4 Dígitos',
        errorMsg: 'o formato de altura não suporta decimais, por favor, insira novamente',
        abnormalMsg: 'Anomalia de registro',
    },
    // 模型合成
    model: {
        loading: 'Carregando...Por favor, aguarde um momento',
        modelLoading: 'Carregando Modelo 3D',
        tabPane: [
            {
                title: 'Tecnologia Deep Real Sense',
                msg: 'Coleta com precisão os detalhes locais do corpo através da digitalização 3D, garante a precisão em milímetros da medição da circunferência, e apresenta claramente as mudanças na forma do corpo após o treino.',
            },
            {
                title: 'Algoritmo de Composição Corporal BDA',
                msg: 'Visbody usa o sistema de medição de composição corporal mais avançado - algoritmo BDA para determinar a composição corporal. Este método de cálculo baseado no volume do corpo avaliará mais precisamente os riscos de saúde trazidos pela obesidade.',
            },
            {
                title: 'Fatores que causaram erros',
                msg: 'Roupas soltas ou algumas decorações no/corpo causarão erros, por favor, use roupas justas ou reduza a quantidade de roupas no seu corpo se quiser obter os dados mais precisos.',
            },
            {
                title: 'Obtenha o seu relatório',
                msg: 'É recomendado marcar a URL da página da web para facilitar a visualização do relatório no futuro. Você também pode enviar este relatório para o seu e-mail para salvá-lo posteriormente.',
            },
        ],
        collect: ['Por favor, marque esta página, fácil de revisar o relatório no futuro.', ''],
        know: 'Eu Entendi',
        reminder: [
            'Recordação gentil',
            'Seu modelo de avatar 3D foi gerado, deslize para a esquerda e para a direita para girar o modelo.',
            'Seu relatório foi gerado e pode ser visualizado clicando no botão "Ver Relatório".',
            'Sua avaliação corporal não foi bem-sucedida, por favor, reveja o relatório de composição corporal.',
            'Sua composição corporal não foi bem-sucedida, por favor, reveja o relatório de avaliação postural.',
            'Sua medição não foi bem-sucedida, por favor, vá ao dispositivo e teste novamente.',
            'A medição da composição corporal não foi bem-sucedida, por favor, vá ao dispositivo e teste novamente.',
            'A avaliação postural não foi bem-sucedida, por favor, vá ao dispositivo e teste novamente.',
        ],
        btn: {
            viewReport: 'Ver Relatório',
            bodyReport: 'Ver Relatório de Composição Corporal',
            postureReport: 'Ver Relatório de Postura Corporal',
            lastReport: 'Ver Último Relatório',
            loading: 'Carregando',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Baixar o Relatório',
            send: 'Enviar Relatório',
            report: 'Relatório',
        },
        reportSuccess: 'Sucesso!',
        tabPane: {
            labelList: ['Hora da Medição', 'Item', 'Composição Corporal', 'Avaliação da Postura', 'Função do Ombro'],
        },
        sendEmail: 'E-mail:',
        requiredMsg: 'Insira o seu endereço de e-mail',
        patternMsg: 'Por favor, insira um endereço de e-mail válido',
        send: 'Enviar',
        download: 'Baixar O Relatório',
        sendReport: 'Enviar Relatório',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Gênero alterado com sucesso',
            height: 'Altura alterada com sucesso',
            age: 'Idade alterada com sucesso',
        },
        logOut: 'Sair',
        personal: 'Centro Pessoal',
        cut: 'Alterar Unidades/Idiomas',
        changeSort: 'Troca de Relatório de Produto',
        setPassword: 'Definir/Alterar palavra-passe',
        accountSecurity: 'Conta e segurança',
        describe: '* Após trocar o modelo do produto, todos os relatórios de medição sob este modelo serão exibidos.',
        describeBtn:
            'Após trocar o modelo do produto, você será redirecionado para o relatório de medição mais recente desse modelo.',
        descReport: 'Relatório de produto trocado com sucesso',
        unit: ['Métrico (kg, cm)', 'Imperial (ft, in, lb)'],
        read: {
            reading: 'Leia',
            privacy: '(Política de Privacidade)',
        },
        setting: 'Configurações',
        form: {
            labelList: ['Telefone', 'Unidades', 'Idiomas', 'Nome', 'Gênero', 'Altura', 'Idade'],
        },
        placeholder: ['Alterar Seu Nome de Usuário', 'Novo Gênero', 'Altura Atualizada', 'Idade Atualizada'],
        btn: {
            cancelBtn: 'Cancelar',
            accomplishBtn: 'Completar',
            confirmBtn: 'Confirmar',
        },
        dialog: [
            'O gênero é uma das bases importantes para a medição da composição corporal. Os dados medidos após a modificação serão diferentes dos dados anteriores. Por favor, confirme se você quer mudar?',
            'A altura é uma das bases importantes para a medição da composição corporal. Os dados medidos após a modificação serão diferentes dos dados anteriores. Por favor, confirme se você quer mudar?',
            'A idade é uma das bases importantes para a medição da composição corporal. Os dados medidos após a modificação serão diferentes dos dados anteriores. Por favor, confirme se você quer mudar?',
        ],
        rules: {
            metricheight: [`Por favor, preencha a faixa de altura correta (2'3" a 6'7")`],
            heightMsg: ['Por favor, preencha a altura dentro de 70cm - 200cm'],
            ageMsg: ['Por favor, preencha a idade dentro de 10 - 99 anos.'],
        },
        heightMsg: 'Por Favor, Reescolha a Altura',
        ageMsg: 'Por Favor, Reescolha a Idade',
        ModelBinding: 'Parece que alguém já escaneou o código, por favor, meça novamente!',
        ReportEmpty: {
            title: 'Você ainda não tem nenhum relatório',
            desc: 'Venha para o scanner corporal 3D Visbody e teste novamente!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Parece que alguém já escaneou o código, por favor, meça novamente!',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Você ainda não tem nenhum relatório',
        desc: 'Venha para o scanner corporal 3D Visbody e teste novamente!',
        descS30: 'Venha para o scanner corporal 3D Visbody-S30 e teste novamente!',
        descM30: 'Venha para o scanner corporal 3D Visbody-M30 e teste novamente!',
    },
    // 用户信息
    userInfo: {
        height: 'Altura:',
        age: 'Idade:',
        unit: '',
        weight: 'peso',
    },
    // 体成分
    mass: {
        title: 'Visão Geral da Avaliação da Composição Corporal',
        titles: 'Composição Corporal',
        springFrame: '',
        massFrame: 'Sem dados de medição para o dia',
        contrast: 'Escolha um relatório para comparar',
        contrastReport: 'Escolha um relatório para comparar',
        noRecord: 'Sem registros',
        score: 'Pontuação',
        status: 'Seu estado atual de composição corporal ',
        WT: 'peso ',
        PBF: 'percentagem de gordura corporal ',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: 'Valores',
            standardRange: 'Faixa padrão',
            comparedWithLastLime: 'Rede',
            comparedNet: 'Comparado com a última pontuação',
            current: '本次测量分数',
            WT: 'Peso',
            FFM: 'Massa Livre de Gordura',
            BFM: 'Massa Gordura',
            LM: 'Massa Muscular',
            TBW: 'Água Total',
            SM: 'MME',
            PROTEIN: 'Proteína',
            TM: 'Minerais',
            BMR: 'Basal Metabolic Rate',
            WHR: 'Relação Cintura-Quadril',
            BMI: 'IMC',
            PBF: 'BFP (Percentagem de Gordura Corporal)',
            VFG: 'Nível de Gordura Visceral',
            unit: 'kg',
            BMRUnit: 'kcal/d',
        },
        // 定义解读
        explain: [
            {
                title: 'Peso ',
                msg: 'O peso é a soma da água corporal, proteína, sal inorgânico e peso corporal.',
            },
            {
                title: 'Massa Livre de Gordura',
                msg: 'Massa corporal magra é o peso corporal total sem gordura.',
            },
            {
                title: 'Massa Gordura',
                msg: 'A massa de gordura corporal é a soma da gordura subcutânea, gordura visceral e gordura muscular.',
            },
            {
                title: 'Massa Muscular',
                msg: 'A massa magra suave é a massa corporal magra, que inclui músculo esquelético, músculo liso e músculo cardíaco.',
            },
            {
                title: 'Água Total',
                msg: 'A maior parte do corpo humano é água com uma quantidade de 50%-70% do peso corporal. E a água corporal está principalmente nas células humanas e nos fluidos corporais, a maioria dos quais está nas células musculares.',
            },
            {
                title: 'MME',
                msg: 'A massa muscular esquelética, também conhecida como músculo estriado, é um tipo de músculo ligado aos ossos. Estes dados contêm a quantidade de Músculo Esquelético.',
            },
            {
                title: 'Proteína',
                msg: 'A proteína é uma substância sólida composta por aminoácidos, presente em todas as células do corpo humano.',
            },
            {
                title: 'Minerais',
                msg: 'O corpo humano é composto por matéria orgânica, matéria inorgânica e água. A matéria inorgânica aqui são sais inorgânicos que representam 5% do peso corporal.',
            },
            {
                title: 'Basal Metabolic Rate',
                msg: 'A taxa de metabolismo basal é a energia total consumida em um dia quando o corpo está em repouso, não afetado por exercícios, objetos físicos, nervosismo, mudanças de temperatura externa, etc.',
            },
            {
                title: 'Relação Cintura-Quadril',
                msg: 'A relação da circunferência da cintura com o quadril, é um indicador importante para determinar a obesidade central.',
            },
            {
                title: 'IMC',
                msg: 'O IMC é principalmente usado para avaliar a aparência da obesidade, e é um padrão comum para medir a gordura corporal.',
            },
            {
                title: 'PGC',
                msg: 'PGC é uma medida da composição corporal que indica quanto do peso corporal é gordura.',
            },
            {
                title: 'Água Intracelular',
                msg: 'É o fluido corporal contido nas células do corpo e é o componente básico do protoplasma.',
            },
            {
                title: 'Água extra-celular',
                msg: 'Normalmente se refere a fluidos corporais extracelulares, incluindo plasma e fluido intersticial entre vasos sanguíneos e células de tecido.',
            },
            {
                title: 'Nível de Gordura Visceral',
                msg: 'A gordura visceral é um indicador importante para avaliar a obesidade oculta.',
            },
            {
                title: 'Idade Metabólica',
                msg: 'Idade metabólica é o desempenho e funções de saúde do metabolismo do corpo.',
            },
            {
                title: 'Rácio ECW/TBW',
                msg: 'O rácio ECW/TBW é a proporção de água extracelular (ECW) na água corporal total (TBW). É um indicador importante para avaliar o equilíbrio hídrico do corpo.',
            },
        ],
        // 节段
        segment: {
            fat: 'Gordura segmental',
            muscle: 'Músculo segmental',
            right: 'Direito',
            left: 'Esquerda',
            standard: 'Normal',
            lowStandard: 'Abaixo',
            superStandard: 'Acima',
            peel: '(Tare)',
        },
    },
    // 体态
    shape: {
        title: 'Visão Geral da Avaliação Corporal',
        titles: 'Postura',
        status: 'Sua condição física atual',
        suggest: 'Sugestão',
        possibility: ', existe a possibilidade de ',
        models: {
            front: 'Frente',
            left: 'Lado esquerdo',
            right: 'Lado direito',
            top: 'Atrás',
            low: 'Abaixo',
            high: 'Acima',
            normal: 'Normal',
        },
        item: {
            deviate: 'Valores',
            result: 'Explicação',
			keAbnormal: 'Suspeita de anomalia',
            normal: 'Normal',
            abnormal: 'Anormal',
            head: 'Postura da cabeça para a frente',
            headSlant: 'Inclinação da cabeça',
            roundShoulderLeft: 'Postura de ombros arredondados (lado esquerdo)',
            roundShoulderRight: 'Postura de ombros arredondados (lado direito)',
            highLowShoudler: 'ombros desiguais',
            pelvis: 'Movimento anterior/posterior da pelve',
            leftKneeCheck: 'avaliação do joelho esquerdo',
            rightKneeCheck: 'avaliação do joelho direito',
            leg: 'Tipo de perna',
            leftLeg: 'Perna esquerda:',
            rightLeg: 'Perna direita:',
        },
        // 定义解读
        explain: [
            {
                title: 'Postura da Cabeça para Frente',
                msg: 'O ângulo entre o ponto da orelha no lado esquerdo e a linha mediana do mesmo lado (esquerdo)',
            },
            {
                title: 'Inclinação da Cabeça',
                msg: 'O ângulo entre o ponto médio da frente da cabeça, o centro do pescoço e a linha mediana frontal.',
            },
            {
                title: 'Postura dos Ombros Arredondados (lado esquerdo)',
                msg: 'O ângulo entre a linha conectando o ponto mais alto no lado esquerdo das costas e a linha tangente ao ombro',
            },
            {
                title: 'Postura dos Ombros Arredondados (lado direito)',
                msg: 'O ângulo entre a linha conectando o ponto mais alto no lado direito das costas e a tangente ao ombro',
            },
            {
                title: 'Ombros Desiguais',
                msg: 'A distância vertical entre os pontos do ombro esquerdo e direito nas costas',
            },
            {
                title: 'Deslocamento anterior/posterior da pélvis',
                msg: 'O ângulo incluído da linha conectando o ponto central do pescoço, o ponto do osso do quadril e o ponto do tornozelo no lado esquerdo',
            },
            {
                title: 'Avaliação do Joelho Esquerdo',
                msg: 'O ângulo incluído da linha de três pontos conectando o ponto do osso do quadril, a articulação do joelho e o ponto do tornozelo no lado esquerdo',
            },
            {
                title: 'Avaliação do Joelho Direito',
                msg: 'O ângulo incluído da linha de três pontos conectando o ponto do osso do quadril, a articulação do joelho e o ponto do tornozelo no lado direito',
            },
            {
                title: 'Formato da Perna',
                msg: 'O ângulo incluído da linha conectando o ponto do osso do quadril, a articulação do joelho e o ponto do tornozelo na frente das pernas esquerda e direita',
            },
            {
                title: 'Anteversão/Retroversão Pélvica',
                msg: 'O ângulo entre a vertical e o plano formado pelas Espinhas Ilíacas Anterossuperiores esquerda e direita e a Sínfise Púbica.'
            },
            {
                title: 'Dismetria dos Membros Inferiores',
                msg: 'Diferença de altura entre os pontos mais baixos das pregas glúteas esquerda e direita.'
            }
        ],
        exception: [
            {
                title: 'Inclinado para o Lado Esquerdo',
                abnormal: '',
            },
            {
                title: 'Inclinado para o Lado Direito',
                abnormal: '',
            },
            {
                title: 'Esquerda Alta',
                abnormal: '',
            },
            {
                title: 'Direita Alta',
                abnormal: '',
            },
            {
                title: 'Inclinação Posterior da Pélvis',
                abnormal: '',
            },
            {
                title: 'Inclinação Anterior da Pélvis',
                abnormal: '',
            },
            {
                title: 'Hiperextensão do Joelho Esquerdo',
                abnormal: '',
            },
            {
                title: 'Flexão Anterior do Joelho Esquerdo',
                abnormal: '',
            },
            {
                title: 'Hiperextensão do Joelho Direito',
                abnormal: '',
            },
            {
                title: 'Flexão Anterior do Joelho Direito',
                abnormal: '',
            },
            {
                title: 'Pernas em Forma de K',
                abnormal: '',
            },
            {
                title: 'Pernas em Forma de D',
                abnormal: '',
            },
            {
                title: 'Pernas em Forma de X',
                abnormal: '',
            },
            {
                title: 'Pernas em Forma de O',
                abnormal: '',
            },
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Distância vertical entre as orelhas e a linha de gravidade corporal',
            },
            {
                msg: 'Ângulo entre a linha que une ambas as orelhas e o plano horizontal',
            },
            {
                msg: 'Distância vertical entre o acrómio esquerdo e a linha de gravidade',
            },
            {
                msg: 'Distância vertical entre o acrómio direito e a linha de gravidade',
            },
            {
                msg: 'Diferença nas linhas que unem a base do pescoço aos acrómios em ambos os lados',
            },
            {
                msg: 'Distância vertical entre a articulação coxofemoral e a linha de gravidade corporal',
            },
            {
                msg: 'Ângulo formado pelo tornozelo, um ponto 1 cm abaixo da articulação do joelho esquerdo e a articulação coxofemoral no plano sagital',
            },
            {
                msg: 'Ângulo formado pelo tornozelo, um ponto 1 cm abaixo da articulação do joelho direito e a articulação coxofemoral no plano sagital',
            },
            {
                msg: 'Ângulo entre as articulações coxofemorais, dos joelhos e dos tornozelos bilaterais no plano coronal',
            },
        ],
        item: {
            pelvis: 'Anteversão pélvica',
        },
    },
    // 围度信息
    girth: {
        title: 'Circunferências',
        present: '(Presente)',
        noHistory: 'Sem dados',
        tpl: [
            {
                title: 'Circunferência do pescoço',
                key: 'neckGirth',
            },
            {
                title: 'Braço esquerdo',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Braço superior direito',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Busto',
                key: 'bustGirth',
            },
            {
                title: 'Cintura Alta',
                key: 'waistGirth',
            },
            {
                title: 'Cintura média',
                key: 'midWaistGirth',
            },
            {
                title: 'Linha Hipline',
                key: 'hipGirth',
            },
            {
                title: 'Coxa esquerda',
                key: 'leftThighGirth',
            },
            {
                title: 'Coxa esquerda do meio',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Circunferência mínima da coxa esquerda',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Circunferência direita da coxa',
                key: 'rightThighGirth',
            },
            {
                title: 'Coxa direita do meio',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Circunferência mínima da coxa direita',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Circunferência esquerda da barriga da perna',
                key: 'leftCalfGirth',
            },
            {
                title: 'Circunferência direita da barriga da perna',
                key: 'rightCalfGirth',
            },
            {
                title: 'Cintura baixa',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Função do Ombro',
        model: {
            val: 'Valores',
            scope: 'Local de Atividade Máxima',
            diff: 'Rede',
        },
        normal: 'Não foram detectadas anormalidades notáveis.',
        normalAll: 'Não foram detectadas anormalidades significativas na função do ombro.',
        conclusion: 'Conclusão',
        analyse: 'Análise: ',
        suggest: 'Sugestão: ',
        cause: 'Por favor, peça conselhos de especialistas para os detalhes.',
    },
    reportTips: {
        title: "Tem a certeza de que pretende eliminar este relatório? Depois de eliminado, não poderá ser recuperado.",
        confirm: "Eliminar",
        success: "Relatório eliminado",
        partial: "O relatório foi eliminado, mas a sincronização de alguns dados falhou. Contacte o administrador.",
        failed: "Não foi possível eliminar. Tente novamente mais tarde.",
        btnMsg: 'OK',
        alaryTips: 'Este relatório foi excluído pelo administrador. Irá saltar para o próximo relatório!',
    },
    saveQr: {
        title: 'Relatório do Scanner Corporal 3D Visbody',
        btnMsg: 'Pressione longamente a imagem para salvá-la em seu telefone.',
        tips: 'Se você achar que não consegue salvar, vá para [Configurações] e abra as permissões correspondentes.',
    },
    vanCalendar: {
        end: 'End',
        start: 'Start',
        title: 'Calendar',
        startEnd: 'Start/End',
        weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthTitle: function monthTitle(year, month) {
            return year + '/' + month
        },
        rangePrompt: function rangePrompt(maxRange) {
            return 'Choose no more than ' + maxRange + ' days'
        },
    },
    share: {
        title: 'Por favor, copie o link abaixo e compartilhe.',
        btnMsg: 'Copiar',
    },
    "waist": {
    "title": "Perímetro da Cintura e Abdômen",
    "hou": "Post.",
    "qian": "Ant."
  },
  "yao_wei_1": "Cintura",
  "yao_bu_fen_shu": "Pontuação da Cintura",
  "waist_fen": "Pontuação",
  "yao_wei": "Perímetro da Cintura",
  "yao_wei_jian_ti_ji": "Volume entre circunferências da cintura",
  "yao_tun_bi": "Relação Cintura-Quadril",
  "lun_kuo_fen_xi": "Análise de Contorno",
  "bei_bu": "Dorsal",
  "tunbu": "Glúteo",
  "bei_bu_ti_ji": "Volume Dorsal",
  "zheng_chang_fan_wei": "Intervalo normal:",
  "shang_ci": "Ant. ",
  "ben_ci": "Atual ",
  "gupen": {
    "zheng_chang": "Normal",
    "qian_qin_yan_chang": "Anteversão Anómala",
    "qian_qin_yi": "Risco de Anteversão",
    "hou_qin_yi": "Risco de Retroversão",
    "hou_qin_yan_chang": "Retroversão Anómala",
    "zuo_chang_yan_chang": "Comprimento Anómalo da Perna Esquerda",
    "zuo_chang_yi": "Risco de Assimetria (Esquerda Maior)",
    "you_chang_yi": "Risco de Assimetria (Direita Maior)",
    "you_chang_yan_chang": "Assimetria Anómala (Direita Maior)"
  },
  "gao_yao_xian": "Cintura Alta",
  "gao_yao_zhong_xian": "Linha Média de Cintura Alta",
  "gao_yao_xia_xian": "Linha Inferior de Cintura Alta",
  "xiao_yao_shang_xian": "Linha Superior de Cintura Baixa",
  "xiao_yao_zhong_xian": "Linha Média de Cintura Baixa",
  "xiao_yao_xian": "Cintura baixa",
  "qv_jian1": "Secção Superior de Cintura Alta",
  "qv_jian2": "Secção Inferior de Cintura Alta",
  "qv_jian_zhong": "Secção de Cintura Média",
  "qv_jian3": "Secção Superior de Cintura Baixa",
  "qv_jian4": "Secção Inferior de Cintura Baixa",
  "celiang.failed": "Medição sem êxito, use roupa justa e permaneça imóvel durante a medição",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Cabeça projetada/inclinada com leve desvio cervical. Atenção à postura sentada.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Cabeça projetada/inclinada com desvio cervical. Recomenda-se controle postural e treino.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Forte inclinação da cabeça e desvio cervical. Avaliação profissional recomendada.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Leve desvio torácico. Melhore o controle postural.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Desvio torácico afeta a estabilidade. Recomendados exercícios específicos.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Desvio torácico evidente e assimetria. Correção profissional recomendada.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Leve desvio lombar, postura equilibrada. Recomendado treino de core.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Desvio lombar afeta a estabilidade. Recomendados exercícios corretivos.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Desvio lombar evidente. Plano de melhoria profissional recomendado.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Hipertonia: elevador da escápula, ECOM e trapézio superior. Fraqueza: flexores profundos do pescoço. Recomendado estabilização e relaxamento.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertonia: ECOM esquerdo e escaleno posterior. Fraqueza: ECOM direito. Recomendado equilíbrio bilateral e relaxamento cervical.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hipertonia: ECOM direito. Fraqueza: ECOM esquerdo e escaleno posterior. Recomendado estabilização simétrica e relaxamento cervical.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertonia: trapézio superior esquerdo. Fraqueza: trapézio médio/inferior. Recomendado treino (médio/inferior) e relaxamento.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Hipertonia: rotadores internos e adutores. Fraqueza: glúteo médio. Recomendado treino do glúteo médio e alongamento.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Hipertonia: glúteo médio e piriforme. Fraqueza: adutores, rotadores internos e LCL. Recomendado estabilização das pernas e relaxamento dos glúteos.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Hipertonia: glúteo médio e piriforme. Fraqueza unilateral: adutores, rotadores internos e LCL. Recomendado treino bilateral.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertonia: isquiotibiais esquerdos e poplíteo. Fraqueza: quadríceps e sóleo. Recomendado treino de quadríceps/sóleo e alongamento.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertonia: quadríceps esquerdo. Fraqueza: glúteo máximo e isquiotibiais. Recomendado treino de glúteos/cadeia posterior e alongamento.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hipertonia: isquiotibiais direitos e poplíteo. Fraqueza: quadríceps e sóleo. Recomendado treino de quadríceps/sóleo e alongamento.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hipertonia: quadríceps direito. Fraqueza: glúteo máximo e isquiotibiais. Recomendado treino de glúteos/cadeia posterior e alongamento.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Leve desvio espinhal. Atenção à postura e treine o core.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Desvio espinhal moderado. Treino profissional recomendado.",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hipertonia: trapézio superior direito. Fraqueza: trapézio médio/inferior. Recomendado treino (médio/inferior) e relaxamento.",
    ...ptLocale,
    ...agrZh,
  "neckReport": {
    "title": "Função cervical",
    "conclusion": "Avaliação da função cervical",
    "loading": "O relatório está sendo gerado. Aguarde.",
    "failed": "Falha ao gerar o relatório.",
    "analysis": "Análise",
    "suggestion": "Sugestão",
    "suggestionText": "Procure um profissional para avaliação adicional e tratamento da causa específica."
  }
}
